import styled from "styled-components";

export const Conitaner = styled.div`
    display: flex;
    flex-direction: column;
    > label{
        font-size: 14px;
        line-height: 16px;
        font-weight: 900;
        color: #4a4a4a;
        margin-bottom: 8px;
    }
`;
export const InputBoxCont = styled.div`
    width: ${p => p.width ? p.width : '100%'};
    height: ${p => p.height ? p.height : '48px'};
    position: relative;
    .startIcon{
        position: absolute;
        left: 12px;
        top: 15px;
    }
`;
export const InputBox = styled.input`
    width: 100%;
    height: 100%;
    border: 1px #E4E4E4 solid;
    padding: ${p=> p.startIcon ? '0 12px 0 40px' : '0 12px'};
    font-family: 'Lato';
    font-size: 14px;
    color: #000000;
    outline: 0;
    border-radius: 4px;
    ${p => p.readOnly && `
        cursor: pointer;
    `}
    ${p => p.isError && `
        border-color: #EB2026;
    `}
    :focus{
        border-color: #008CFF;
    }
`;  